module.exports = __webpack_public_path__ + "img/solutions_2.e2944331.png";